export default __webpack_public_path__ + "static/media/800X900 3.c4ca08de.png";